var _circle, _circle2, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 5.5,
    stroke: "#0D0119",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 15,
    stroke: "#0D0119",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_329_10242",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01953 27.144C6.51806 22.4298 11.0913 19 16.5005 19C21.9097 19 26.4829 22.4298 27.9815 27.144C25.0738 30.139 21.0045 32 16.5005 32C11.9965 32 7.92718 30.139 5.01953 27.144Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.01953 27.144L3.11351 26.5381L2.751 27.6785L3.58454 28.5371L5.01953 27.144ZM27.9815 27.144L29.4165 28.5371L30.25 27.6785L29.8875 26.5381L27.9815 27.144ZM6.92555 27.7498C8.15332 23.8875 11.9396 21 16.5005 21V17C10.243 17 4.88281 20.9722 3.11351 26.5381L6.92555 27.7498ZM16.5005 21C21.0613 21 24.8477 23.8875 26.0754 27.7498L29.8875 26.5381C28.1182 20.9722 22.758 17 16.5005 17V21ZM26.5465 25.7508C23.9999 28.3739 20.4418 30 16.5005 30V34C21.5671 34 26.1477 31.904 29.4165 28.5371L26.5465 25.7508ZM16.5005 30C12.5592 30 9.00111 28.3739 6.45452 25.7508L3.58454 28.5371C6.85326 31.904 11.4339 34 16.5005 34V30Z",
    fill: "#0D0119",
    mask: "url(#path-3-inside-1_329_10242)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0101d90381026899cc3cda1f01258276.svg";
export { ForwardRef as ReactComponent };